import { RouteRecordRaw } from "vue-router"
import PageCompany from "./pages/PageCompany.vue"
import { useAuthStore } from "@core/stores/auth.store"

// ====================================
// Module Company Space - Routes
// ====================================
export const routes = [
    {
        path: "/user/entreprise",
        name: "PageCompany",
        component: PageCompany,
        meta: {
            requiresAuth: true,
            layout: "header-sidebar",
            sidebar: "user",
        },
        beforeEnter: async (_to, _from, next) => {
            const authStore = useAuthStore()
            // Au rechargement, les données user (companyId, subscription) peuvent ne pas être
            // encore chargées ; s'assurer de les avoir avant de vérifier isClientHomeys / isUc2Pro
            if (authStore.isLogged && !authStore.userId) {
                await authStore.fetchUser()
            }
            if (authStore.isClientHomeys || authStore.isUc2Pro) {
                next()
            } else {
                next({ name: "PageUserSettings" })
            }
        },
    },
] as RouteRecordRaw[]
